import { EntertainmentEventVenuesEffects } from './entertainment-event-venues.effects';
import { EntertainmentEventPerformancesEffects } from './entertainment-event-performances.effects';
import { EntertainmentEventEffects } from './entertainment-event.effects';
import { EntertainmentEventBookingEffects } from './entertainment-event-booking.effects';
import { EntertainmentEventTicketTypeEffects } from './entertainment-event-ticket-type.effects';

export const effects: any[] = [
  EntertainmentEventVenuesEffects,
  EntertainmentEventPerformancesEffects,
  EntertainmentEventEffects,
  EntertainmentEventBookingEffects,
  EntertainmentEventTicketTypeEffects,
];

export * from './entertainment-event-venues.effects';
export * from './entertainment-event-performances.effects';
export * from './entertainment-event.effects';
export * from './entertainment-event-booking.effects';
export * from './entertainment-event-ticket-type.effects';
